import { createReducer } from 'typesafe-actions'
import { AuditLogsItemDto, AuditLogsItemRequestDto, ILogsResponseDto } from '@sparling/financial-common'
import { omit } from 'lodash'
import { ActionTypes } from '../types'
import { LoadingStateEnum } from '../../types'
import {
  getAuditLogsRequest,
  getAuditLogsSuccess,
  getAuditLogsFailure,
  getLogTypesRequest,
  getLogTypesSuccess,
  getLogTypesFailure,
  resetAuditLogsFilters,
} from '../actions'

export type AuditLogsState = {
  logs: {
    loading: LoadingStateEnum
    data: ILogsResponseDto<AuditLogsItemDto>
    filters: AuditLogsItemRequestDto
    error: Error | null
  }
  types: {
    loading: LoadingStateEnum
    data: Array<string>
    error: Error | null
  }
}

export const initialState = {
  logs: {
    loading: LoadingStateEnum.IDLE,
    data: {
      items: [],
      meta: {
        itemCount: 0,
        totalItems: 0,
        itemsPerPage: 0,
        totalPages: 0,
        currentPage: 0,
      },
    },
    filters: {},
    error: null,
  },
  types: {
    loading: LoadingStateEnum.IDLE,
    data: [],
    error: null,
  },
}

export const auditLogs = createReducer<AuditLogsState, ActionTypes>(initialState)
  .handleAction(getAuditLogsRequest, (state, { payload }) => ({
    ...state,
    logs: {
      ...state.logs,
      filters: {
        ...state.logs.filters,
        ...payload,
        page: Object.keys(omit(payload, 'page')).length > 0 ? 1 : payload.page,
      },
      loading: LoadingStateEnum.LOADING,
    },
  }))
  .handleAction(getAuditLogsSuccess, (state, { payload }) => ({
    ...state,
    logs: {
      ...state.logs,
      loading: LoadingStateEnum.SUCCESS,
      data: payload,
    },
  }))
  .handleAction(getAuditLogsFailure, (state, { payload }) => ({
    ...state,
    logs: {
      ...state.logs,
      loading: LoadingStateEnum.ERROR,
      data: initialState.logs.data,
      error: payload,
    },
  }))
  .handleAction(resetAuditLogsFilters, (state) => ({
    ...state,
    logs: {
      ...state.logs,
      filters: initialState.logs.filters,
    },
  }))
  .handleAction(getLogTypesRequest, (state) => ({
    ...state,
    types: {
      ...state.types,
      loading: LoadingStateEnum.LOADING,
    },
  }))
  .handleAction(getLogTypesSuccess, (state, { payload }) => ({
    ...state,
    types: {
      ...state.types,
      loading: LoadingStateEnum.SUCCESS,
      data: payload,
    },
  }))
  .handleAction(getLogTypesFailure, (state, { payload }) => ({
    ...state,
    types: {
      ...state.types,
      loading: LoadingStateEnum.ERROR,
      data: initialState.types.data,
      error: payload,
    },
  }))
